<template>
  <div class="main_header">
        <div class="content">
            <div class="menu">
                <ol v-if="!is_mobile()">
                    <li>
                        <div>
                            <router-link :to="{name: 'friends'}" >חברים במכרז השקוף</router-link>
                        </div>
                    </li>
                    <li id="tamalink" @click="scrollTo('tama38')">
                        <div >יתרונות מרכזיים</div>
                    </li>
                    <li @click="scrollTo('lawyers')">
                        <div>עורכי הדין</div>
                    </li>
                    <li @click="scrollTo('quotes')">
                        <div>עדויות דיירים</div>
                    </li>
                    <li @click="scrollTo('form_section')">
                        <div>איך זה עובד</div>
                    </li>
                </ol>
                <nav v-else role="navigation">
                    <div id="menuToggle">
                        <input type="checkbox" @change="mobileMenuOpen=!mobileMenuOpen" :checked="mobileMenuOpen" />
                        <span></span>
                        <span></span>
                        <span></span>
                        <ul id="menu">
                            <li id="tamalink" @click="scrollTo('tama38')">
                                <div >יתרונות מרכזיים</div>
                            </li>
                            <li @click="scrollTo('lawyers')">
                                <div>עורכי הדין</div>
                            </li>
                            <li @click="scrollTo('how')">
                                <div>איך זה עובד</div>
                            </li>
                            <li @click="scrollTo('quotes')">
                                <div>עדויות דיירים</div>
                            </li>
                          <!-- <a href="https://erikterwan.com/" target="_blank"><li>Show me more</li></a> -->
                        </ul>
                    </div>
                </nav>
            </div>
            <div class="logo_container">
                <router-link :to="mainPageLink" class="logo"></router-link>
            </div>
            <div @click="redirect" class="btn" v-if="userLogged" >אזור אישי</div>
             <router-link to="/login" class="btn" v-else>התחברות</router-link>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mobileMenuOpen: false,
            userLogged: false
        }
    },
    beforeMount() {
        if(this.get_me() && this.get_me().id > 0) this.userLogged  = true;
    },  
    methods: {
        redirect() {
            if(this.user_type ) {
                if(this.user_type  == 'lawyer') {
                    this.$router.push('/projects_manager');
                }
                else if(this.user_type  == 'entrepreneur') {
                    this.$router.push('/list');
                }
                else return false;
            }
            else return false;
        },
        scrollTo(id) {
            // check if the router in '/' page and if not redirect to the main page and then scroll
            if (this.$route.path !== '/') {
                this.$router.push('/');
                setTimeout(() => {
                    this.scrollTo(id);
                }, 500);
                return;
            }
            if (this.is_mobile()) this.mobileMenuOpen = false
            let ele = document.getElementById(id);
            if (ele) window.scrollTo({ top: ele.offsetTop - 90, behavior: "smooth" });
        }
    }
}
</script>

<style lang="scss" scoped>
.main_header { 
    &{ z-index: 9999; position: fixed; top: 0; right: 0; left: 0;background: #0C076B;border-bottom: 2px solid rgba(255, 255, 255, 0.10);
    display: flex;justify-content: center;align-items: center; }
    .content {display: flex; justify-content: space-between; align-items: center; height: var(--headerHeight);position: relative; min-width: 100%; padding-inline: var(--gap);}
    .logo_container {
        position: absolute;width: 200px;display: flex;justify-content: center;align-items: center;left:0;right: 0;margin: auto;
        .logo { display: block; background-image: url("../../assets/logo2.svg"); background-position: center center; background-size: contain; background-repeat: no-repeat;    height: 30px; width: 200px;}
    }
    .menu {display: flex; z-index: 9999999999; margin-bottom: 5px;
        ol {display: flex; gap: 32px; list-style: none; font-family: var(--font2);
            li { cursor: pointer;
                div, a {  transition: 0.3s ease scale;
                    &:hover{ scale: 1.1; }
                }
                &, div { color: white;}
            }
        }
    }
}
.btn {width: fit-content;background: white;color:var(--homepage_blue);padding: var(--gap);}



#menuToggle {display: block;position: relative;top: 0px;left: 25px;z-index: 1;-webkit-user-select: none;user-select: none;}
#menuToggle a {text-decoration: none;color: #232323;transition: color 0.3s ease;}
#menuToggle a:hover {color: tomato;}
#menuToggle input {display: block;width: 40px;height: 32px;position: absolute;top: -7px;left: -5px;cursor: pointer;opacity: 0;z-index: 2;-webkit-touch-callout: none;}
#menuToggle span {display: block;width: 33px;height: 4px;margin-bottom: 5px;position: relative;background: white;border-radius: 3px;z-index: 1;transform-origin: 4px 0px;transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0), background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),opacity 0.55s ease;}
#menuToggle span:first-child {transform-origin: 0% 0%;}
#menuToggle span:nth-last-child(2) {transform-origin: 0% 100%;}
#menuToggle input:checked ~ span {opacity: 1;transform: rotate(45deg) translate(-2px, -1px);background: #232323;}
#menuToggle input:checked ~ span:nth-last-child(3) {opacity: 0;transform: rotate(0deg) scale(0.2, 0.2);}
#menuToggle input:checked ~ span:nth-last-child(2) {transform: rotate(-45deg) translate(0, -1px);}
#menu {position: absolute;width: 300px;margin: -110px -12px 0 0;padding: 50px;padding-top: 125px;background: #ededed;list-style-type: none;-webkit-font-smoothing: antialiased;transform-origin: 0% 0%;transform: translate(105%, 0);transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0);}
#menu li {padding: 10px 0;font-size: 22px;}
#menuToggle input:checked ~ ul {transform: none;}
</style>